import React from 'react';

const ReadOnlyInput = React.forwardRef((props, ref) => {
    return <input {...props} ref={ref} readOnly />;
});

ReadOnlyInput.displayName = 'ReadOnlyInput';

export default ReadOnlyInput;
